import { render, staticRenderFns } from "./ComplieAddModelAssociation.vue?vue&type=template&id=389ccee3&scoped=true"
import script from "./ComplieAddModelAssociation.vue?vue&type=script&lang=js"
export * from "./ComplieAddModelAssociation.vue?vue&type=script&lang=js"
import style0 from "./ComplieAddModelAssociation.vue?vue&type=style&index=0&id=389ccee3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ccee3",
  null
  
)

export default component.exports